module.exports = __webpack_public_path__ + "img/full3-min.25d9150c.png";